import { useState } from 'react';
import { Container, Card } from 'reactstrap';
import { Row, Col } from 'src/componentes/grid';
import { FormattedMessage } from 'react-intl';

import Dialog from 'src/componentes/dialog';
import Pagination from 'src/componentes/pagination';

const GuiaDatasetId = ({ abrirModalUnico, remove, handleClose }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [abrirModal] = useState(abrirModalUnico);

  const handleCloseGuia = () => {
    document.body.classList.remove('modal-open');

    setTimeout(() => {
      remove && remove();
      handleClose && handleClose(undefined, undefined);
    }, 300);
  };

  const renderGuia2 = () => (
    <Row style={{ marginTop: 25, marginBottom: 30 }}>
      <Col md={12}>
        <Card
          style={{ height: 380, width: '65%', margin: '0 auto' }}
          className="justify-content-center"
        >
          <img
            src={'/static/images/pbi/actioDatasetId.png'}
            width={'100%'}
            height="auto"
            alt="imgActioDatasetId"
          />
        </Card>

        <h6 className="text-center" style={{ marginTop: 15 }}>
          <FormattedMessage id="coleCodigoCopiadoTela" />
        </h6>
      </Col>
    </Row>
  );

  const renderGuia1 = () => (
    <Row className="my-4">
      <Col md={4}>
        <Card style={{ height: 380 }} className="px-4">
          <h5 className="text-center my-4">
            <FormattedMessage id="configuracoes" />
          </h5>

          <p style={{ marginLeft: 10 }}>
            <FormattedMessage id="infoDatasetPBI" />
          </p>

          <p style={{ marginLeft: 10 }}>
            <FormattedMessage id="infoUrlDatasetPBI" />
          </p>
        </Card>
      </Col>

      <Col md={8}>
        <Card style={{ height: 380 }} className="justify-content-center">
          <img
            src={'/static/images/pbi/pbiDatasetUrl.png'}
            width={'100%'}
            height="auto"
            alt="img"
          />
        </Card>
      </Col>
    </Row>
  );

  return (
    <Dialog width={1200} onRequestClose={handleCloseGuia}>
      <Container>
        <h4 className="text-center" style={{ marginTop: 5 }}>
          <FormattedMessage id="guiaDatasetIdPBI" />
        </h4>

        {!abrirModal && currentPage === 1 ? renderGuia1() : renderGuia2()}

        {!abrirModal && (
          <Row>
            <Col md={5}></Col>
            <Col md={6}>
              <Pagination
                prev
                next
                first
                last
                ellipsis
                boundaryLinks
                style={{ display: 'inline' }}
                activePage={currentPage}
                totalPages={2}
                totalDisplayed={2}
                pageChanged={setCurrentPage}
              />
            </Col>
          </Row>
        )}
      </Container>
    </Dialog>
  );
};

export default GuiaDatasetId;
